import { Link } from 'react-router-dom';
import type { Resource } from '@/mocks/resources';
import { getCategoryName } from '@/mocks/resources';

interface ResourceCardProps {
  resource: Resource;
  showRank?: number;
}

export default function ResourceCard({ resource, showRank }: ResourceCardProps) {
  return (
    <Link
      to={`/detail/${resource.id}`}
      className="group block cursor-pointer"
      title={`${resource.title} - 国语对白做受69影视详情`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={resource.cover}
          alt={`${resource.title} 国语对白影音资源封面`}
          title={`${resource.title} 国语影音作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-70" />
        <span className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-md bg-primary-900/85 px-2 py-0.5 text-[11px] font-label text-background-50 backdrop-blur">
          {getCategoryName(resource.category)}
        </span>
        <span className="absolute top-2 right-2 inline-flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-semibold font-label text-foreground-950">
          <i className="ri-star-fill text-[10px]" />
          {resource.rating.toFixed(1)}
        </span>
        {typeof showRank === 'number' && (
          <span className="absolute bottom-2 left-2 inline-flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-xs font-bold font-label text-foreground-950">
            {showRank}
          </span>
        )}
      </div>
      <h3 className="mt-2 truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors">
        {resource.title}
      </h3>
      <p className="mt-1 flex items-center gap-2 text-xs text-foreground-600">
        <span>{resource.year}</span>
        <span className="text-background-400">·</span>
        <span>{resource.region}</span>
      </p>
    </Link>
  );
}